import { combineEpics, Epic, ofType } from "redux-observable";
import { from, Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { AuthActions } from "../auth/actions";
import { FetchableError, FetchableSuccess } from "../common/fetchable/helpers";
import { CryptoActions } from "./actions";
import { CryptoDTO } from "./models/dto";
import { CryptoService } from "./service";

const getAllFraudReportEpic: Epic<CryptoActions.Actions> = (action$) =>
  action$.pipe(
    ofType(CryptoActions.ActionTypes.getAllFraudReport),
    switchMap<
      CryptoActions.Actions,
      Observable<
        | FetchableError
        | FetchableSuccess<CryptoDTO.Responses.GetAllFraudReport.T>
      >
    >(() => CryptoService.getAllFraudReport()),
    map((x) => CryptoActions.setAllFraudReport(x))
  );

const setAllFraudReportPaginationEpic: Epic<CryptoActions.Actions> = (
  action$
) =>
  action$.pipe(
    ofType(CryptoActions.ActionTypes.setAllFraudReportPagination),
    switchMap<
      CryptoActions.SetAllFraudReportPagination,
      Observable<
        | FetchableError
        | FetchableSuccess<CryptoDTO.Responses.GetAllFraudReport.T>
      >
    >((action) => {
      return CryptoService.getAllFraudReport(action.payload);
    }),
    map((x) => CryptoActions.setAllFraudReport(x))
  );

const getFraudReportSummaryEpic: Epic<CryptoActions.Actions> = (action$) =>
  action$.pipe(
    ofType(CryptoActions.ActionTypes.getFraudReportSummary),
    switchMap<
      CryptoActions.Actions,
      Observable<
        | FetchableError
        | FetchableSuccess<CryptoDTO.Responses.GetFraudReportSummary.T>
      >
    >(() => CryptoService.getFraudReportSummary()),
    map((x) => CryptoActions.setFraudReportSummary(x))
  );

const dependencies: Epic<
  AuthActions.Actions | CryptoActions.Actions,
  CryptoActions.Actions
> = (action$) =>
  action$.pipe(
    ofType(AuthActions.ActionTypes.authDone),
    switchMap(() =>
      from([
        CryptoActions.resetAllFraudReport(),
        CryptoActions.resetFraudReportSummary(),
      ])
    )
  );

export const cryptoEpic = combineEpics(
  getAllFraudReportEpic,
  setAllFraudReportPaginationEpic,
  getFraudReportSummaryEpic,
  dependencies
);
